/**
 * @file shallowEqual Judge whether two variables are shallow equal.
 * @author yuzong(yuzong@tencent.com)
 */
import { objectEqual } from './objectEqual';
/**
 * Judge whether two objects are shallow equal.
 *
 * @param first First variable.
 * @param second Second variable.
 * @return Are the first and second shallow equal.
 */

export function shallowEqual(first, second) {
  return objectEqual(first, second, false);
}